export default function generateId() {
  var chars = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var text = '';
  var remainingChars = chars;
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  while (remainingChars) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
    remainingChars -= 1;
  }

  return text;
}